const initialState = {
  dispatchList: null,
  driverDispatchList: null,
  loading: true
}

export default initialState
